import type { ProfilecardProvider } from '@atlaskit/editor-common/provider-factory/profile-card-provider';
import type {
	MentionsChangedHandler,
	MentionsPluginOptions,
} from '@atlaskit/editor-plugin-mentions/types';
import type { MentionProvider } from '@atlaskit/mention/types';

interface Props {
	options: {
		currentUserId?: string;
		enableAgentSectioning?: boolean;
		getIsRovoPanelOpen?: () => boolean;
		handleMentionsChanged: MentionsChangedHandler;
		mentionNodeDataProvider?: MentionsPluginOptions['mentionNodeDataProvider'];
		onAgentMentionChatClick?: MentionsPluginOptions['onAgentMentionChatClick'];
		showAgentMentionsLabsLozenge?: boolean;
	};
	providers: {
		mentionProvider: Promise<MentionProvider> | undefined;
		profilecardProvider: Promise<ProfilecardProvider> | undefined;
	};
}

/** Builds the mention plugin options used by the Confluence full-page preset. */
export function mentionsPluginOptions({ options, providers }: Props): MentionsPluginOptions {
	return {
		sanitizePrivateContent: true,
		insertDisplayName: true,
		allowZeroWidthSpaceAfter: true,
		profilecardProvider: providers.profilecardProvider,
		handleMentionsChanged: options.handleMentionsChanged,
		mentionNodeDataProvider: options.mentionNodeDataProvider,
		mentionProvider: providers.mentionProvider,
		currentUserId: options.currentUserId,
		enableAgentSectioning: options.enableAgentSectioning,
		showAgentMentionsLabsLozenge: options.showAgentMentionsLabsLozenge,
		getIsRovoPanelOpen: options.getIsRovoPanelOpen,
		onAgentMentionChatClick: options.onAgentMentionChatClick,
	};
}
